import React, { createContext, useEffect, useState } from 'react';
import { useSubscription } from '@apollo/client';
import { ACCOUNT_INFO } from '../../graphql/querys/account-info';

export const AccountInfoContext = createContext();

const AccountInfoProvider = ({ client, accountId, userId, refreshIdToken, children }) => {
    const [account, setAccount] = useState(null);
    const [user, setUser] = useState(null);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(client ? true : false);

    const { data, loading: subcriptionLoading, error } = useSubscription(
        ACCOUNT_INFO,
        {
            variables: { accountId, userId },
            client
        }
    );

    useEffect(() => {
        setLoading(subcriptionLoading);
    }, [subcriptionLoading])

    useEffect(() => {
        // console.log('user info', user);
        if (user) {
            setProfile(user.profile);
        } else {
            setProfile(null);
        }
    }, [user]);

    useEffect(() => {
        // console.log('account info', account);
        if (account) {
            if (account.members?.length === 1) {
                setUser(account.members[0].user);
            } else {
                setUser(null);
            }
        } else {
            setUser(null);
        }
    }, [account]);

    useEffect(() => {
        // console.log('account data', data);
        if (data?.accounts_by_pk) {
            setAccount(data.accounts_by_pk);
        } else {
            setAccount(false);
        }    
    }, [data]);

    useEffect(() => {
        // console.log('account error?', error);
        if (error && error.message.toString().includes('JWTExpired')) {
            refreshIdToken();
        }
    }, [refreshIdToken, error])

    return (
        <AccountInfoContext.Provider value={{
            account,
            balance: account?.balance || 0,
            profile,
            loading,
            client,
        }}>
            {children}
        </AccountInfoContext.Provider>
    )
}

export default AccountInfoProvider;

